const processByType = data => {
    const cData = [];
    cData.push(['Tipo', 'Total']);
    data.map(item => cData.push([item.petition_type, item.total]));
    return cData;
}

const processByStatus = data => {
    const cData = [];
    cData.push(['Estado', 'Total']);
    data.map(item => cData.push([item.petition_status, item.total]));
    return cData;
}

const processByCategory = data => {
    const cData = [];
    cData.push(['Categoría', 'Total']);
    data.map(item => cData.push([item.category, item.total]));
    return cData;
}

export {
    processByType,
    processByStatus,
    processByCategory
}